module.exports = __webpack_public_path__ + "img/136.3dbe8c9d.jpg";